/**
 * @function handleRole
 * @param { array } roles
 * @param { string } id
 * @param { string } name
 * @param { string } value
 * @returns { array }
 */
function handleRole(roles, id, name, value) {
	const results = roles.map((role) => {
		if (role.id === undefined) {
			const msg = 'The role id is undefined!';
			throw new Error(msg);
		}

		if (role.id === id) return { ...role, [name]: value };

		return role;
	});

	return results;
}

export default handleRole;
